<template>

  <select-org
    :label="label"
    type="Backhaul"
    v-model="formData"
    :required="required"
    :placeholder="placeholder"
    :help-text="helpText"
    :size="size"
    :disabled="disabled"
    :no-form="noForm"
    :limit="limit"
    :full-object="fullObject"
    @change="updated"
    />

</template>

<script>

import SelectOrg from '@/components/atoms/selects/SelectOrg'

export default {
  name: 'select-backhaul-provider',

  components: {
    SelectOrg
  },

  props: {

    label: {
      type: String,
      default: 'Backhaul Provider'
    },

    value: {
//      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: 'default'
    },

    placeholder: {
      type: String,
      default: 'Backhaul Provider'
    },

    helpText: {
      type: String,
      default: null
    },

    fullObject: {
      type: Boolean,
      default: false
    },

    limit: {
      type: Array,
      default: null
    },
    noForm: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  },

  data () {
    return {
      formData: this.value
    }
  }
}
</script>
